/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sound_close': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M257.493 322.4l215.574-133.056c24.981-15.413 57.877-7.915 73.493 16.747a52.172 52.172 0 018.107 27.914v555.99c0 29.098-23.883 52.672-53.334 52.672a53.885 53.885 0 01-28.266-8L257.493 701.6H160c-41.237 0-74.667-33.013-74.667-73.739V396.14c0-40.726 33.43-73.739 74.667-73.739h97.493zm26.134 58.4a32.299 32.299 0 01-16.96 4.8H160c-5.888 0-10.667 4.715-10.667 10.539v231.733c0 5.813 4.779 10.539 10.667 10.539h106.667a32.336 32.336 0 0116.96 4.8l207.04 127.776V253.013L283.627 380.8zm548.938 137.6l86.475 86.475a30.57 30.57 0 11-43.232 43.242l-86.475-86.464-86.474 86.475a30.57 30.57 0 11-43.232-43.243l86.474-86.474-86.474-86.475a30.57 30.57 0 1143.232-43.232l86.474 86.475 86.475-86.475a30.57 30.57 0 1143.232 43.232l-86.475 86.475z"/>'
  }
})
